import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAuthFromKeycloak } from '../state/slices/authSlice';
import { jwtDecode, JwtPayload } from 'jwt-decode';

const CallbackComponent = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (auth.isAuthenticated && auth.user?.access_token) {
      dispatch(
        setAuthFromKeycloak({
          isKeycloak: true,
          access: {
            access: auth.user.access_token,
            refresh: auth.user.refresh_token,
          },
        }),
      );

      const decoded = jwtDecode<JwtPayload>(auth.user.access_token);
      console.log('Decoded token:', decoded);

      const userType = auth.user.state; // ← this is your user_type
      console.log('Returned user_type:', userType);

      switch (userType) {
        case 'albertan':
          navigate('/dashboard');
          break;
        case 'lawenforcement':
          navigate('/law/dashboard');
          break;
        case 'tecadmin':
          navigate('/admin/dashboard');
          break;
        default:
          navigate('/dashboard');
      }
    }
  }, [auth.isAuthenticated, auth.user?.access_token, dispatch, navigate]);

  return <div>Completing login...</div>;
};

export default CallbackComponent;
